import { useEffect, useState } from 'react';

import { Sort } from './data-table';

const sortData = (
  data: Sort[],
  payload: { sortBy: keyof Sort['rows']; reversed: boolean }
) => {
  const { sortBy } = payload;

  if (!sortBy) {
    return data;
  }

  return [...data].sort((a, b) => {
    if (sortBy === 'updated_at') {
      if (payload.reversed) {
        return (
          new Date(b.rows[sortBy]).getTime() -
          new Date(a.rows[sortBy]).getTime()
        );
      }

      return (
        new Date(a.rows[sortBy]).getTime() - new Date(b.rows[sortBy]).getTime()
      );
    }
    if (sortBy === 'id') {
      if (payload.reversed) {
        return +b.rows[sortBy] - +a.rows[sortBy];
      }

      return +a.rows[sortBy] - +b.rows[sortBy];
    }

    if (payload.reversed) {
      return b.rows[sortBy].localeCompare(a.rows[sortBy]);
    }

    return a.rows[sortBy].localeCompare(b.rows[sortBy]);
  });
};

export const useSortTable = (data: Sort[]) => {
  const [sortedData, setSortedData] = useState(data);
  const [sortBy, setSortBy] = useState<string>();
  const [isReversed, setIsReversed] = useState(false);

  const sort = (field: keyof Sort['rows']) => {
    const reversed = field === sortBy ? !isReversed : false;
    setIsReversed(reversed);
    setSortBy(field);
  };

  useEffect(() => {
    if (sortBy) {
      setSortedData(sortData(data, { reversed: isReversed, sortBy }));
    } else {
      setSortedData(data);
    }
  }, [data, isReversed, sortBy]);

  return { isReversed, sort, sortBy, sortedData };
};
